module.exports = __webpack_public_path__ + "static/img/image 11@2x.9775b2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/20230804/image 11@2x.png
// module id = kSLq
// module chunks = 1